import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { getViewIndex } from './commonSelectors';
import { createSeasonContexts } from '../utils/seasonUtils';
import { SeasonContext } from '../types/Season';

const getSeasons = (state: AppState) => state.seasons;

export const getCurrentSeason = createSelector(
  [
    getSeasons,
    getViewIndex
  ],
  (seasons, index: number) => seasons.activeSeasons[index]?.id ?? ''
);

export const getActiveSeasons = createSelector(
  [getSeasons],
  (seasons) => seasons.activeSeasons
);

export const getCurrentSeasonYear = createSelector(
  getCurrentSeason,
  (season: string): string => season.substring(0, 4)
);

export const getCurrentSeasonCropCode = createSelector(
  getCurrentSeason,
  (season: string): string => season.split(':')[1] ?? ''
);

export const getSeasonsList = createSelector([getSeasons], (seasonsState) => seasonsState.list);

export const getSeasonContexts = createSelector(
  [getSeasonsList, getActiveSeasons],
  (seasonsList, activeSeasons): SeasonContext[] =>
    createSeasonContexts(seasonsList, activeSeasons),
);
